<template>
    <div>
        <div
            v-if="showBox" class="xiuxiu-box"
            @click="handleClick"
        >
            <div class="xiuxiu-box-left">
                <img
                    src="https://fenwan.cdn.bcebos.com/cms/gamenow/2021-11/1637221622654/2b87691c8363.png"
                    alt=""
                    class="xiuxiu-icon"
                >
                <img>
                <div>
                    <p class="pApp">咻咻星球APP查看</p>
                    <p class="pFind">发现好玩游戏，和同好玩家交流</p>
                </div>
            </div>
            <div>
                <div
                    v-if="true" class="download"
                    @click.stop="download"
                >下载</div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import {downloadApk} from '@/utils/browser';
import {getDeepValue} from '@/utils/utility';
export default {
    props: {
        subscribeCallback: {
            type: Function,
            default: () => {},
        },
        cid: {
            type: String,
            default: '',
        },
        answerId: {
            type: String,
            default: '',
        },
        from: {
            type: String,
            default: '',
        },
        appId: {
            type: String,
            default: '',
        },
        doDisplayLog: {
            type: Function,
            default: () => {},
        },
        doClickLog: {
            type: Function,
            default: () => {},
        },
    },
    data() {
        return {
            appData: {},
            showBox: false,
        };
    },
    async created() {
        let params = {
            data: {
                app_id: this.appId,
                from: this.from,
                cid: this.cid,
                answer_id: this.answerId,
            },
        };
        this.appData = await api.zone.getXiuxiuAppInfo(params);
        if (Object.keys(this.appData).length !== 0) {
            this.doDisplayLog({
                gameId: this.app_id,
                gameName: this.$root.gameName,
                platform: this.appData ? 'android' : 'ios',
                boxVersion: '', // 版本号
                gameType: '', // 游戏类型
                title: this.$root.title, // 标题
            }, 'xiuxiuAppBottomBtn');
            this.showBox = true;
        }
    },
    methods: {
        subscribe() {
            this.subscribeCallback && this.subscribeCallback();
        },
        handleClick() {
            this.$emit('showXiuxiuDrawer', true);
            this.doClickLog('xiuxiuAppBottomBtn', {
                gameId: this.app_id,
                gameName: this.$root.gameName,
                platform: this.appData ? 'android' : 'ios',
                boxVersion: '', // 版本号
                gameType: this.$root.extData.gameType || '', // 游戏类型
                title: this.$root.title, // 标题
            });
        },
        download() {
            const url = getDeepValue(this.appData, 'app_package.downloadurl');
            const icon = getDeepValue(this.appData, 'app_icon');
            const packageName = getDeepValue(this.appData, 'package_name');
            downloadApk(url, icon, packageName);
        },
    },
};
</script>

<style lang="scss">
@import "~@/common/style/mixin/utils";

html {
  @include root-font-size();
}

html,
body {
  padding: 0;
  margin: 0;
}
.xiuxiu-box {
  width: 1242px;
  height: 191px;
  background: #fff;
  justify-content: space-between;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-image: linear-gradient(180deg, #edfffc 0%, #ffffff 100%);
  display: flex;
  .xiuxiu-box-left {
    margin-left: 15px;
    width: 600px;
    display: flex;
    line-height: 191px;
    .xiuxiu-icon {
      width: 119px;
      height: 119px;
      margin-top: 36px;
      margin-left: 51px;
      //margin-bottom: 36px;
      border-radius: 30px;
    }
    .pApp {
      width: 430px;
      height: 42px;
      font-family: PingFangSC-Medium;
      font-size: 42px;
      color: #2d4b46;
      letter-spacing: 0;
      line-height: 42px;
      font-weight: 500;
      margin-top: 48px;
      margin-left: 21px;
      //margin-bottom: 21px;
      box-sizing: border-box;
      position: relative;
    }
    .pFind {
      width: 878px;
      height: 33px;
      opacity: 0.5;
      font-family: PingFangSC-Regular;
      font-size: 36px;
      color: #2d4b46;
      letter-spacing: 0;
      line-height: 33px;
      font-weight: 400;
      margin-left: 21px;
      //margin-bottom: 47px;
      //transform: scale(0.8);
      position: absolute;
      //left: 40px;
      top: 80px;
      //transform: scale(calc(8 / 12));
    }
  }
  .download {
    width: 192px;
    height: 91px;
    background: #00CCA6;
    border-radius: 46.5px;
    font-size: 60px;
    line-height: 100px;
    color: #fff;
    text-align: center;
    font-size: 42px;
    margin-top: 50px;
    margin-right: 50px;
    margin-bottom: 50px;
  }
}
</style>